import { FC } from 'react';

import cx from 'classnames';

import styles from './Expander.module.scss';
export const Expander: FC<{ className?: string }> = ({ className }) => (
  <div className={cx(styles.expander, className)} />
);
